import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Companion_getInstance2192nrpo98q6y as Companion_getInstance } from '../../../../../ktor-ktor-http/io/ktor/http/HttpStatusCode.mjs';
import { constructCallableReference23y65rf941mch as constructCallableReference } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { Send_instance3jwyi367vhqvc as Send_instance } from './api/CommonHooks.mjs';
import { Unit_instance3vdlo4e4f5ggx as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { get_authority2s3hk87lssumy as get_authority } from '../../../../../ktor-ktor-http/io/ktor/http/Url.mjs';
import { HttpRequestBuilder15f2nnx9sjuv1 as HttpRequestBuilder } from '../request/HttpRequest.mjs';
import { takeFrom3rd40szpqy350 as takeFrom } from '../../../../../ktor-ktor-http/io/ktor/http/URLParser.mjs';
import { isSecurex1qiiavqi0xu as isSecure } from '../../../../../ktor-ktor-http/io/ktor/http/URLProtocol.mjs';
import { get_authorityakhc3pgcrb9j as get_authority_0 } from '../../../../../ktor-ktor-http/io/ktor/http/URLBuilder.mjs';
import { Companion_getInstance1pptfj8vjmgsz as Companion_getInstance_0 } from '../../../../../ktor-ktor-http/io/ktor/http/HttpMethod.mjs';
import { setOf45ia9pnfhe90 as setOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Sets.mjs';
import { KtorSimpleLogger1xdphsp5l4e48 as KtorSimpleLogger } from '../../../../../ktor-ktor-utils/io/ktor/util/logging/KtorSimpleLogger.web.mjs';
import { EventDefinition1fymk8xrdelhn as EventDefinition } from '../../../../../ktor-ktor-events/io/ktor/events/Events.mjs';
import { createClientPluginjwpvufjows5r as createClientPlugin } from './api/CreatePluginUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_ALLOWED_FOR_REDIRECT() {
  _init_properties_HttpRedirect_kt__ure7fo();
  return ALLOWED_FOR_REDIRECT;
}
var ALLOWED_FOR_REDIRECT;
function get_LOGGER() {
  _init_properties_HttpRedirect_kt__ure7fo();
  return LOGGER;
}
var LOGGER;
function get_HttpResponseRedirectEvent() {
  _init_properties_HttpRedirect_kt__ure7fo();
  return HttpResponseRedirectEvent;
}
var HttpResponseRedirectEvent;
function get_HttpRedirect() {
  _init_properties_HttpRedirect_kt__ure7fo();
  return HttpRedirect;
}
var HttpRedirect;
var HttpRedirectConfigClass;
function HttpRedirectConfig() {
  if (HttpRedirectConfigClass === VOID) {
    class $ {
      constructor() {
        this.m5p_1 = true;
        this.n5p_1 = false;
      }
    }
    initMetadataForClass($, 'HttpRedirectConfig', HttpRedirectConfig);
    HttpRedirectConfigClass = $;
  }
  return HttpRedirectConfigClass;
}
function isRedirect(_this__u8e3s4) {
  _init_properties_HttpRedirect_kt__ure7fo();
  var tmp0_subject = _this__u8e3s4.u54_1;
  return tmp0_subject === Companion_getInstance().d53_1.u54_1 || tmp0_subject === Companion_getInstance().e53_1.u54_1 || (tmp0_subject === Companion_getInstance().j53_1.u54_1 || (tmp0_subject === Companion_getInstance().k53_1.u54_1 || tmp0_subject === Companion_getInstance().f53_1.u54_1)) ? true : false;
}
function HttpRedirectConfig$_init_$ref_rhym9t() {
  return constructCallableReference(() => new (HttpRedirectConfig())(), 0, 0, 218, '<init>');
}
function HttpRedirect$lambda($this$createClientPlugin) {
  _init_properties_HttpRedirect_kt__ure7fo();
  var checkHttpMethod = $this$createClientPlugin.s5m_1.m5p_1;
  var allowHttpsDowngrade = $this$createClientPlugin.s5m_1.n5p_1;
  var tmp = Send_instance;
  $this$createClientPlugin.v5m(tmp, HttpRedirect$lambda$slambda(checkHttpMethod, allowHttpsDowngrade, $this$createClientPlugin));
  return Unit_instance;
}
function *invoke$handleCall(_this__u8e3s4, context, origin, allowHttpsDowngrade, client, $completion) {
  var call = origin;
  var requestBuilder = context;
  while (true) {
    var previousProtocol = call.p5i().y5i().z55_1;
    var previousAuthority = get_authority(call.p5i().y5i());
    if (!isRedirect(call.r5g().f5j()))
      return call;
    var location = call.r5g().w51().c2o('Location');
    if (location == null) {
      get_LOGGER().y4t('Location header missing from redirect response ' + call.p5i().y5i().toString() + '; returning response as is');
      return call;
    }
    client.k5g_1.c4u(get_HttpResponseRedirectEvent(), call.r5g());
    get_LOGGER().a4u('Received redirect response to ' + location + ' for request ' + call.p5i().y5i().toString());
    // Inline function 'kotlin.apply' call
    var this_0 = new (HttpRequestBuilder())();
    this_0.q5l(requestBuilder);
    this_0.y5h_1.j55_1.a5();
    takeFrom(this_0.y5h_1, location);
    if (!allowHttpsDowngrade && isSecure(previousProtocol) && !isSecure(this_0.y5h_1.m55())) {
      get_LOGGER().a4u('Blocked redirect from ' + call.p5i().y5i().toString() + ' to ' + location + ' due to HTTPS downgrade');
      return call;
    }
    if (!(previousAuthority === get_authority_0(this_0.y5h_1))) {
      this_0.a5i_1.a4q('Authorization');
      get_LOGGER().a4u('Removing Authorization header for cross-authority redirect: ' + (previousAuthority + ' -> ' + this_0.y5h_1.w56()));
    }
    requestBuilder = this_0;
    call = yield* _this__u8e3s4.z5o(requestBuilder, $completion);
  }
}
function HttpRedirect$lambda$slambda($checkHttpMethod, $allowHttpsDowngrade, $this_createClientPlugin) {
  return constructCallableReference(function *($this$on, request, $completion) {
    var origin = yield* $this$on.z5o(request, $completion);
    var tmp;
    if ($checkHttpMethod && !get_ALLOWED_FOR_REDIRECT().t2(origin.p5i().x5i())) {
      return origin;
    }
    return yield* /*#__NOINLINE__*/invoke$handleCall($this$on, request, origin, $allowHttpsDowngrade, $this_createClientPlugin.r5m_1, $completion);
  }, 2);
}
var properties_initialized_HttpRedirect_kt_klj746;
function _init_properties_HttpRedirect_kt__ure7fo() {
  if (!properties_initialized_HttpRedirect_kt_klj746) {
    properties_initialized_HttpRedirect_kt_klj746 = true;
    ALLOWED_FOR_REDIRECT = setOf([Companion_getInstance_0().x51_1, Companion_getInstance_0().c52_1]);
    LOGGER = KtorSimpleLogger('io.ktor.client.plugins.HttpRedirect');
    HttpResponseRedirectEvent = new (EventDefinition())();
    var tmp = HttpRedirectConfig$_init_$ref_rhym9t();
    HttpRedirect = createClientPlugin('HttpRedirect', tmp, HttpRedirect$lambda);
  }
}
//region block: exports
export {
  get_HttpRedirect as get_HttpRedirect1lgx3wewnhrb0,
};
//endregion

//# sourceMappingURL=HttpRedirect.mjs.map
